module.exports = __webpack_public_path__ + "img/v4_h2.13434242.png";